import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { Table } from 'antd';

const WardDetails = () => {
    const { id } = useParams();
    const [wardDetails, setWardDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchWardDetails = async () => {
            try {
                const response = await axios.get(`https://ward3-chandrapur-api.palikaapp.com/api/ward/${id}/details`);
                setWardDetails(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchWardDetails();
    }, [id]);

    if (loading) {
        return <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>;
    }

    if (error) {
        return <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>Error: {error.message}</div>;
    }

    // Define columns for the tables
    const peopleRepresentativesColumns = [
        {
            title: 'क्र.सं',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'नाम',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'फोन',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'इमेल',
            dataIndex: 'email',
            key: 'email',
        },
    ];

    const wardStaffsColumns = [
        {
            title: 'क्र.सं',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'नाम',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'फोन',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'इमेल',
            dataIndex: 'email',
            key: 'email',
        },
    ];

    return (
        <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}> {/* Light grey background */}
            <Header />
            <Sidebar />
            <div style={{ margin: '120px auto 0 auto', padding: '20px', maxWidth: '1000px', width: '100%', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', flex: '1' }}>
                {wardDetails && (
                    <div>
                        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>वडाको बिस्तृत विवरण</h2>

                        <p><strong>नाम:</strong> {wardDetails.name}</p>
                        <p><strong>फोन:</strong> {wardDetails.phone}</p>
                        <p><strong>इमेल:</strong> {wardDetails.email}</p>

                        <h2 style={{ marginBottom: '2rem', textAlign: 'center' ,textDecoration:'underline'}}>जनप्रतिनिधि</h2>
                        <Table
                            dataSource={wardDetails.peopleRepresentatives}
                            columns={peopleRepresentativesColumns}
                            pagination={false}
                            rowKey="id"
                            style={{ marginBottom: '2rem' }}
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th {...props} style={{ backgroundColor: '#A9A9A9', color: 'white' }} /> // Dark grey header
                                    ),
                                },
                            }}
                        />

                        <h2 style={{ textAlign: 'center', marginBottom: '3rem',textDecoration:'underline' }}>वडा कर्मचारी</h2>
                        <Table
                            dataSource={wardDetails.wardStaffs}
                            columns={wardStaffsColumns}
                            pagination={false}
                            rowKey="id"
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th {...props} style={{ backgroundColor: '#A9A9A9', color: 'white' }} /> // Dark grey header
                                    ),
                                },
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default WardDetails;
